'use client';

import { useState } from 'react';
import { completeOnboarding } from '../api/complete-onboarding';
import { buildOnboardingPayload } from './build-onboarding-payload';
import type { SplitWizardSubmitContextValue, SplitWizardSubmitError } from '@/widgets/registration-wizard/model/split-wizard-submit-context';


type Options = {
    /** Визард собрал компанию (шаг «company»): её нужно отправить вместе с планом и биллингом. */
    includeCompany?: boolean;
};


export const useCompleteOnboarding = ({ includeCompany = false }: Options = {}): SplitWizardSubmitContextValue => {
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ]     = useState<SplitWizardSubmitError | null>(null);

    const submit: SplitWizardSubmitContextValue['submit'] = async (data) => {
        setError(null);

        const payload = buildOnboardingPayload(data, includeCompany);

        if (!payload) {
            setError({
                kind   : 'generic',
                message: includeCompany
                    ? 'Company, plan and billing address are required'
                    : 'Plan and billing address are required',
            });
            return null;
        }

        setLoading(true);

        try {
            const response = await completeOnboarding(payload);

            if (!response.ok) {
                setError({ kind: 'generic', message: response.error });
                return null;
            }

            return { checkoutUrl: response.checkoutUrl };
        } catch (err) {
            setError({
                kind   : 'generic',
                message: err instanceof Error ? err.message : 'Unexpected error',
            });
            return null;
        } finally {
            setLoading(false);
        }
    };

    return { submit, loading, error, setError };
};
